import * as React from 'react';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { connect } from 'react-redux';
import { channelAction } from '../../actions/channelAction';
import moment from 'moment'

interface IUsersProps {
	dispatch: Dispatch<any>;
	channelData: any;
	callback: any;
	id: string;
}

const UserChannel: React.SFC<IUsersProps> = ({ dispatch, channelData, id }) => {

	let dateFormat = "MM/DD/YYYY";

	const [favChannelList, setFavChannelList] = useState([]);
	const [isListLoaded, setIsListLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);

	React.useEffect(() => {
		setIsErrorOnPage(false);
		setIsListLoaded(false);
		dispatch(channelAction.channelGetFavourite({ pageNumber: 1, pageSize: 3, userId: id }));
	}, [id]);


	if (channelData) {
		if (channelData.isError && !isErrorOnPage) {
			setIsErrorOnPage(true);
		}

		if (channelData && channelData.isFavChannelLoaded) {
			channelData.isFavChannelLoaded = false;
			setFavChannelList(channelData.favChannelData);
			setIsListLoaded(true);
		}
	}

	return (
		<>
			{isListLoaded && !isErrorOnPage && channelData && channelData.favChannelData.length > 0 ?
				<table className="table text-center" data-testid="tableFavouriteChannel">
					<thead>
						<tr>
							<th className="td50" data-testid="otherChannelTitle" key={"favChannel"} scope="col">Channel</th>
							<th key={"lastTime"} data-testid="otherChannelDate" scope="col">Last Interaction</th>
						</tr>
					</thead>
					<tbody>
						{channelData && channelData.favChannelData.map((data: any) =>
							<tr key={"otherChannelRow" + data.channelId}>
								<td data-testid={"otherChannel" + data.channelId} key={data.title + data.channelId}>
									{data.title}
								</td>
								<td data-testid={"otherChannelDate" + data.channelId} key={data.lastInteraction}>
									{moment(data.lastInteraction).format(dateFormat)}</td>
							</tr>
						)}
					</tbody>
				</table> :
				<h5 className="text-center">No data found</h5>
			}
		</>
	)
}

const mapStateToProps = (state: any) => {
	const { channelData } = state;
	return {
		channelData
	};
};

export default connect(mapStateToProps)(UserChannel);
